<script setup>
import { computed, useSlots } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import Button from 'dashboard/components-next/button/Button.vue';
import ComposeConversation from 'dashboard/components-next/NewConversation/ComposeConversation.vue';
import AddLabel from 'dashboard/components-next/Label/AddLabel.vue';
import SectionLayout from 'dashboard/components-next/SectionLayout.vue';

const props = defineProps({
  buttonLabel: {
    type: String,
    default: '',
  },
  selectedContact: {
    type: Object,
    default: () => ({}),
  },
  labelMenuItems: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['goToContactsList', 'labelAction']);

const { t } = useI18n();
const slots = useSlots();
const route = useRoute();

const contactId = computed(() => route.params.contactId);

const handleLabelAction = (event) => {
  emit('labelAction', event);
};
</script>

<template>
  <SectionLayout :show-back-button="true" class="overflow-y-auto" :title="$t('CONTACTS_LAYOUT.HEADER.TITLE')">
    <template #header-left>
      <div class="items-center gap-3 hidden md:flex">
        <AddLabel :label-menu-items="labelMenuItems" @update-label="handleLabelAction" />
        <ComposeConversation :contact-id="contactId">
          <template #trigger="{ toggle }">
            <button class="input-base bg-grass-400 text-white flex items-center gap-2 text-base" @click="toggle">
              <span>
                {{ buttonLabel }}
              </span>
              <span class="i-lucide-send h-5 w-5" />
            </button>
          </template>
        </ComposeConversation>
      </div>
    </template>
    <div class="flex items-center gap-3 md:hidden">
    <AddLabel :label-menu-items="labelMenuItems" @update-label="handleLabelAction" />
    <ComposeConversation :contact-id="contactId">
          <template #trigger="{ toggle }">
            <button class="input-base bg-grass-400 text-white flex items-center gap-2 text-base" @click="toggle">
              <span>
                {{ buttonLabel }}
              </span>
              <span class="i-lucide-send h-5 w-5" />
            </button>
          </template>
    </ComposeConversation>
    </div>
    <div class="mt-3 flex flex-col gap-6 lg:gap-0 lg:flex-row bg-n-gray-1 dark:bg-n-vars-black-br/30 rounded-lg">
      <div class="flex flex-col flex-1 transition-all duration-300 p-0 pt-3 md:p-3 lg:p-6 dark:bg-n-vars-black-br/30 lg:dark:bg-transparent">
        <main class="flex-1 overflow-y-visible">
          <div class="w-full mx-auto">
            <slot name="default" />
          </div>
        </main>
      </div>

      <div v-if="slots.sidebar" class="overflow-y-auto dark:bg-n-vars-black-br/30
           w-full lg:w-[440px] lg:max-w-[440px] lg:min-w-[200px] 
           px-3 py-6 border-l border-n-gray-2 dark:border-none dark:rounded-lg pb-0 mb-6
           ">
        <slot name="sidebar" />
      </div>
    </div>
  </SectionLayout>
</template>